import { Subscription } from 'rxjs';
import { Component, OnInit, Inject, HostListener, ViewChild, ElementRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { ModalMessageConfirmComponent } from '@component/modal-message-confirm/modal-message-confirm.component';
import { Router } from '@angular/router';
import { WorkspaceNewService } from '@services/workspace-new.service';
import { WorkspaceConfModalDto } from '@dto/workspace-conf-modal-dto';
import { Constants } from '@utils/constants';
import { WorkspaceNewSaveDto } from '@dto/workspace-new-save-dto';
import { AuthService } from '@auth/auth.service';
import { WorkspaceItemContentDto } from '@dto/workspace-item-content-dto';
import { PositionDto } from '@dto/position.dto';
import { NotificationsService } from 'angular2-notifications';
import { ConfigService } from '../../services/webFeeder/config.service';
import { CustomWorkspaceModalComponent } from '../custom-workspace-modal/custom-workspace-modal.component';
import { AutoLogoutService } from '@auth/auto-logout-service.service';

@Component({
  selector: 'app-workspace-conf-modal',
  templateUrl: './workspace-conf-modal.component.html'
})
export class WorkspaceConfModalComponent implements OnInit {
  dialog: MatDialog;
  public wksBackModalSubscription: Subscription;
  public wksOptions = [];
  public customNameWorkspace = '';
  public wksOptSelected = 0;
  public loading = true;
  public wksOptSel: WorkspaceConfModalDto;
  public messageInfo1 = Constants.WKS_WORKSPACE_CONF_MODAL_INFO1;
  public messageInfo2 = Constants.WKS_WORKSPACE_CONF_MODAL_INFO2;
  @ViewChild('inputCustomName') inputCustomName: ElementRef;
  loadingBtn: boolean = false;
  @HostListener('mousemove')
  onMouseMove() {
    this._autoLogoutService.resetTime();
  }
  @HostListener('click')
  onClick() {
    this._autoLogoutService.resetTime();
  }
  @HostListener('body:keydown', ['$event'])
  onkeydown(event) {
    if (event.key === 'Escape') {
      if (this.wksOptSelected === 6 || this.wksOptSelected === 0) {
        if (!this.workspaceService.validNumberWorkspace()) {
          this._NotificationService.info('', Constants.WORKSPACE_MSG001);
          return false;
        } else {
          this.dialogRef.close();
        }
      }
    }
    // return false;
  }

  constructor(
    dialog: MatDialog,
    public dialogRef: MatDialogRef<ModalMessageConfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private workspaceService: WorkspaceNewService,
    private _service: NotificationsService,
    private configService: ConfigService,
    private _autoLogoutService: AutoLogoutService,
    private _NotificationService: NotificationsService
  ) {
    this.dialog = dialog;
    this.wksOptSel = new WorkspaceConfModalDto(0, '', '', '', false);

    if (this.data && this.data.workspaceName !== undefined && this.data.workspaceName !== '') {
      this.customNameWorkspace = this.data.workspaceName;
    }
    this.wksBackModalSubscription = this.configService.wksBackModal$.subscribe(res => {
      if (res) {
        this.wksOptSelected = 0;
      }
    });
  }

  ngOnInit() {
    this.workspaceService.loadPredefinedWorkspaces()
      .subscribe(defaultWks => {
        if (defaultWks) {
          this.mountAndPush(defaultWks);
        }
        this.loading = false;
        setTimeout(() => {
          this.inputCustomName.nativeElement.focus();
        }, 500);
      });
  }

  validateForm(): boolean {
    if (this.customNameWorkspace.length === 0 || this.wksOptSelected <= 0) {
      return false;
    } else {
      return true;
    }
  }

  private mountAndPush(workspacesArr: Array<any>) {
    for (let i = 0; i < workspacesArr.length; i++) {
      let isPersonalized = false;
      const JsonDataArr = JSON.parse(workspacesArr[i].JsonData);
      if (JsonDataArr.content.length === 0) {
        isPersonalized = true;
      } else {
        isPersonalized = false;
      }
      const cardConfigArray = workspacesArr[i].Name.split('-');
      if (cardConfigArray && cardConfigArray.length === 3) {
        const wksConfDto = new WorkspaceConfModalDto(
          workspacesArr[i].Id,
          cardConfigArray[0],
          cardConfigArray[1].trim(),
          JsonDataArr,
          isPersonalized,
          cardConfigArray[2].trim()
        );
        this.wksOptions.push(wksConfDto);
      } else {
        this._NotificationService.warn('', Constants.WORKSPACE_MSG028);
      }
    }
  }

  submit() {
    this.loadingBtn = true;
    if (!this.wksOptSel.jsondata) {
      this._NotificationService.warn('', Constants.WORKSPACE_MSG022);
      this.loadingBtn = false;
      return;
    } else {
      if (this.workspaceService.validateWorkspaceName(this.customNameWorkspace, null)) {
        if (this.workspaceService.isNameBlank(this.customNameWorkspace)) {
          this._service.warn('', Constants.WORKSPACE_MSG013);
          this.loadingBtn = false;
        } else {
          if (this.wksOptSel.isPersonalize) {
            const dialogConfig = this.dialog.open(CustomWorkspaceModalComponent, {
              position: { top: '0' },
              maxWidth: '100vw',
              width: '100vw',
              height: '100vh',
              data: {
                wksOptSelected: this.wksOptSelected,
                customNameWorkspace: this.customNameWorkspace
              },
              disableClose: true
            });
            dialogConfig.afterClosed().subscribe(closeall => {
              if (closeall) {
                this.dialogRef.close(closeall);
              }
            })
            this.loadingBtn = false;
          } else {
            this.dialogRef.close();
            this.workspaceService.loadWorkspaces().subscribe(resp => {
              let indexTabNew = 0;
              for (let i = 0; i < resp.length; i++) {
                if (resp[i].IndexTab > indexTabNew) {
                  indexTabNew = resp[i].IndexTab;
                }
              }
              indexTabNew = indexTabNew + 1;
              const content: Array<WorkspaceItemContentDto> = this.workspaceService.convertDtoContenToSave(this.wksOptSel.jsondata);
              const wksDtoSave: WorkspaceNewSaveDto = new WorkspaceNewSaveDto(this.customNameWorkspace, content, indexTabNew);
              this.loadingBtn = false;
              this.workspaceService.addWks(wksDtoSave).subscribe(data => {
                if (data) {
                  this.dialogRef.close(data);
                }
              });
            });
          }
        }
      } else {
        this._NotificationService.warn('', Constants.WORKSPACE_MSG002);
        this.loadingBtn = false;
      }
    }
  }

  closeModal(): void {
    if (!this.workspaceService.validNumberWorkspace()) {
      this._NotificationService.info('', Constants.WORKSPACE_MSG001);
    } else {
      this.dialogRef.close();
    }
  }

  selectValue(value) {
    setTimeout(() => {
      this.wksOptSelected = value;
      for (let k = 0; k < this.wksOptions.length; k++) {
        if (this.wksOptions[k].id === value) {
          this.wksOptSel = this.wksOptions[k];
          for (let i = 0; i < Constants.MAX_WKS_CONF; i++) {
            if (this.wksOptions[i].id !== value) {
              const elem = document.getElementById(this.wksOptions[i].id);
              elem.className = 'select-pre-built';
            } else {
              const elem = document.getElementById(this.wksOptions[i].id);
              elem.className = 'select-pre-built selected';
            }
          }
          break;
        }
      }
    }, 100);
  }
}
